import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/HospitalDashbord/EmailVerify";
import { oneKlicks } from "../SDK/oneclick";
import { debugLog } from "../utils/debug";
import { toast } from 'react-toastify';
import { getuserdata } from "../services/apiService";
import BreakTimeModal from "./Components/BrackTime";
import { Table } from 'antd';
import DayTimeSlots from "../layouts/Doctor/Components/DayTimeSlots";

const AppointmentSettings = () => {
    const [userdata, setUserdata] = useState({});
    const [tabsest, setTabseset] = useState("Personal Details");
    const [hospitalList, setHospitalList] = useState([]);
    const [appointmentSettings, setAppointmentSettings] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedHospital, setSelectedHospital] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedBreakTime, setSelectedBreakTime] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [formData, setFormData] = useState({
        start_time: '',
        end_time: '',
        intervals: '',
        durations: '',
        content: '',
        spaces: '1',
        custom_spaces: '',
        week_days: [],
        selected_days: [],
        day_time_slots: {},
        consultant_fee: '',
        book_before: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const sanitizeHospitalName = (name) => {
        if (!name) return '';
        return name
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&nbsp;/g, ' ')
            .trim();
    };

    useEffect(() => {
        getHospitaldetails();
    }, []);

    useEffect(() => {
        if (userdata.id) {
            getAppointmentSettings();
        }
    }, [userdata.id]);

    const getHospitaldetails = async () => {
        const userData = await getuserdata('full');
        console.log("userData getHospitaldetails HospitalAdmin:", userData);
        setUserdata(userData);
    }


    const getAppointmentSettings = async () => {
        try {
            setLoading(true);
            setError(null);
            const tableSchema = "";
            const tableName = "appointment_settings";
            const conditions = {
                hospital_id: userdata.id,
                doctor_id: ""
            };
            const orderBy = "id DESC";
            const search = {};
            const pagination = {};
            const margedata = [
                {
                    target_table: "users",
                    target_column: "id",
                    target_value: "hospital_id",
                    target_label: "hospital_name"
                }
            ];
            console.log("getAppointmentSettings conditions", conditions);
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("getAppointmentSettings response", response.data);
            if (response.success === true) {
                setAppointmentSettings(response.data);
            }
        } catch (err) {
            console.error('Error fetching appointment settings:', err);
            setError(err.message || 'An error occurred while fetching appointment settings');
        } finally {
            setLoading(false);
        }
    }

    

    const handleClickOutside = (e) => {
        if (!e.target.closest('.hospital-search-container')) {
            setShowDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.durations) {
            newErrors.durations = 'Please select appointment duration';
        }
        if (formData.spaces === 'others' && !formData.custom_spaces) {
            newErrors.custom_spaces = 'Please enter number of spaces';
        }
        if (formData.selected_days.length === 0) {
            newErrors.selected_days = 'Please select at least one day';
        }
        if (!formData.consultant_fee) {
            newErrors.consultant_fee = 'Please enter consultation fee';
        } else if (isNaN(formData.consultant_fee) || parseFloat(formData.consultant_fee) <= 0) {
            newErrors.consultant_fee = 'Please enter a valid fee amount';
        }

        if (!formData.book_before) {
            newErrors.book_before = 'Please select book before';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            const weekDays = [...formData.week_days];
            if (checked) {
                weekDays.push(value);
            } else {
                const index = weekDays.indexOf(value);
                if (index > -1) {
                    weekDays.splice(index, 1);
                }
            }
            setFormData(prev => ({
                ...prev,
                week_days: weekDays
            }));
        } else if (name === 'spaces') {
            setFormData(prev => ({
                ...prev,
                spaces: value,
                custom_spaces: value === 'others' ? prev.custom_spaces : ''
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const resetForm = () => {
        setFormData({
            start_time: '',
            end_time: '',
            intervals: '',
            durations: '',
            content: '',
            spaces: '1',
            custom_spaces: '',
            week_days: [],
            selected_days: [],
            day_time_slots: {},
            consultant_fee: '',
            book_before: ''
        });
        setSearchQuery('');
        setSelectedHospital(null);
        setErrors({});
        setIsEditing(false);
        setEditingId(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        try {
            debugLog('Submitting form data:', formData);
            const tableSchema = "";
            const tableName = "appointment_settings";
            const data = {
                "hospital_id": userdata.id,
                "doctor_id": "",
                "start_time": "",
                "end_time": "",
                "intervals": formData.intervals,
                "durations": formData.durations,
                "content": formData.content,
                "spaces": formData.spaces === 'others' ? formData.custom_spaces : formData.spaces,
                "week_days": JSON.stringify(formData.selected_days),
                "selected_days": JSON.stringify(formData.selected_days),
                "day_time_slots": JSON.stringify(formData.day_time_slots),
                "consultant_fee": formData.consultant_fee,
                "book_before": formData.book_before,
                "status": "pending"
            };
            const conditions = isEditing ? { id: editingId } : {};
            const response = isEditing 
                ? await oneKlicks.update(tableSchema, tableName, data, conditions)
                : await oneKlicks.create(tableSchema, tableName, data, conditions);

            console.log("response", response);
            if (response.success == true) {
                setErrors(prev => ({
                    ...prev,
                    submit: isEditing ? 'Appointment updated successfully.' : 'Form submitted successfully.'
                }));
                resetForm();
                getAppointmentSettings(); // Refresh the list
                toast.success(isEditing ? 'Appointment updated successfully.' : 'Form submitted successfully.');
            }

        } catch (error) {
            debugLog('Error submitting form:', error);
            setErrors(prev => ({
                ...prev,
                submit: isEditing ? 'Failed to update appointment.' : 'Failed to submit form. Please try again.'
            }));
        } finally {
            setIsSubmitting(false);
        }
    };

    const formatTime = (time) => {
        if (!time) return '';
        const hours = parseInt(time.substring(0, 2));
        const minutes = time.substring(2);
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${minutes} ${period}`;
    };

    const formatDuration = (minutes) => {
        if (!minutes) return '';
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (hours === 0) return `${mins} minutes`;
        if (mins === 0) return `${hours} hour${hours > 1 ? 's' : ''}`;
        return `${hours} hour${hours > 1 ? 's' : ''} ${mins} minutes`;
    };

    const formatWeekDays = (days) => {
        if (!days) return '';

        // If days is already an array, use it directly
        if (Array.isArray(days)) {
            const dayMap = {
                'mon': 'Monday',
                'tue': 'Tuesday',
                'wed': 'Wednesday',
                'thu': 'Thursday',
                'fri': 'Friday',
                'sat': 'Saturday',
                'sun': 'Sunday'
            };
            return days.map(day => dayMap[day]).join(', ');
        }

        // If days is a string, try to parse it
        try {
            const parsedDays = JSON.parse(days);
            if (Array.isArray(parsedDays)) {
                const dayMap = {
                    'mon': 'Monday',
                    'tue': 'Tuesday',
                    'wed': 'Wednesday',
                    'thu': 'Thursday',
                    'fri': 'Friday',
                    'sat': 'Saturday',
                    'sun': 'Sunday'
                };
                return parsedDays.map(day => dayMap[day]).join(', ');
            }
        } catch (e) {
            console.warn('Error parsing week days:', e);
        }

        return '';
    };

    const formatBreakType = (type) => {
        if (!type) return '';
        return type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    const handleEditClick = (appointmentSetting) => {
        setIsEditing(true);
        setEditingId(appointmentSetting.id);
        
        // Set the selected hospital
        setSelectedHospital(appointmentSetting.hospital_name[0]);
        setSearchQuery(appointmentSetting.hospital_name[0]?.display_name || '');

        // Parse selected_days if it's a string
        let selectedDays = [];
        if (appointmentSetting.selected_days) {
            try {
                selectedDays = JSON.parse(appointmentSetting.selected_days);
            } catch (e) {
                console.error('Error parsing selected_days:', e);
                selectedDays = [];
            }
        }

        // Parse day_time_slots - it's already an object
        let dayTimeSlots = appointmentSetting.day_time_slots || {};

        // Parse week days if it's a string (for legacy support)
        let weekDays = appointmentSetting.week_days;
        if (typeof weekDays === 'string') {
            try {
                weekDays = JSON.parse(weekDays);
            } catch (e) {
                weekDays = [];
            }
        }

        console.log('Edit - selectedDays:', selectedDays);
        console.log('Edit - dayTimeSlots:', dayTimeSlots);

        // Set form data with proper structure for DayTimeSlots
        setFormData({
            start_time: appointmentSetting.start_time,
            end_time: appointmentSetting.end_time,
            intervals: appointmentSetting.intervals,
            durations: appointmentSetting.durations,
            content: appointmentSetting.content || '',
            spaces: appointmentSetting.spaces,
            custom_spaces: appointmentSetting.spaces === 'others' ? appointmentSetting.spaces : '',
            week_days: weekDays,
            selected_days: selectedDays,
            day_time_slots: dayTimeSlots,
            consultant_fee: appointmentSetting.consultant_fee,
            book_before: appointmentSetting.book_before
        });

        // Scroll to form
        document.querySelector('.dc-form-appointment').scrollIntoView({ behavior: 'smooth' });
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this appointment setting?')) {
            try {
                const tableSchema = "";
                const tableName = "appointment_settings";
                const conditions = { id: id };
                
                const response = await oneKlicks.delete(tableSchema, tableName, conditions);
                
                if (response.success === true) {
                    toast.success('Appointment setting deleted successfully');
                    getAppointmentSettings(); // Refresh the list
                } else {
                    toast.error(response.message || 'Failed to delete appointment setting');
                }
            } catch (error) {
                console.error('Error deleting appointment:', error);
                toast.error('An error occurred while deleting the appointment setting');
            }
        }
    };

    const [showBreakTimeModal, setShowBreakTimeModal] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    

    const handleBracktime = (appointmentSetting) => {
        setShowBreakTimeModal(true);
        setSelectedAppointment(appointmentSetting);
    };

    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {userdata.activation_key == null && (
                    <EmailVerify />
                )}

                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <div className="dc-dashboardbox">
                                <div className="dc-dashboardboxtitle">
                                    <h2>Hospital Appointment Settings</h2>
                                </div>
                                <div className="dc-dashboardboxcontent dc-clinicloc-holder">
                                    <div className="dc-tabscontenttitle">
                                        <h3>Current Settings</h3>
                                    </div>
                                    <div className="dc-content-holder">
                                        {appointmentSettings.length > 0 ? (
                                            appointmentSettings.map((appointmentSetting) => (
                                                <div key={appointmentSetting.id} className="dc-clinics">
                                                    <div className="dc-clinics-content">
                                                        <div style={{ display: 'flex' }}>
                                                            <div className="col-md-6" style={{paddingLeft: '0px'}}>
                                                                <a href="#">Hospital</a>
                                                                <h4 style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                                    {sanitizeHospitalName(appointmentSetting?.hospital_name[0]?.display_name || '')}
                                                                    
                                                                </h4>
                                                            </div>
                                                            <div className="dc-btnarea col-md-6" style={{ textAlign: 'right', display: 'flex', gap: '10px',flexDirection: 'row-reverse', paddingRight: '0px' }}>
                                                                <a
                                                                    href="#"
                                                                    className="dc-btn dc-btn-sm"
                                                                    style={{ width: '120px', minWidth: '120px' }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleEditClick(appointmentSetting);
                                                                    }}
                                                                >
                                                                    Edit
                                                                </a>
                                                                
                                                                
                                                            </div>
                                                        </div>
                                                        <div className="time-details" style={{ marginBottom: '8px' }}>
                                                                    {(() => {
                                                                        let selectedDays = [];
                                                                        let dayTimeSlots = {};
                                                                        
                                                                        // Parse day-based time slots
                                                                        if (appointmentSetting.selected_days && appointmentSetting.day_time_slots) {
                                                                            try {
                                                                                // selected_days is a JSON string, day_time_slots is already an object
                                                                                selectedDays = JSON.parse(appointmentSetting.selected_days);
                                                                                dayTimeSlots = appointmentSetting.day_time_slots; // Already an object
                                                                                
                                                                                console.log('Parsed selectedDays:', selectedDays);
                                                                                console.log('dayTimeSlots:', dayTimeSlots);
                                                                            } catch (e) {
                                                                                console.error('Error parsing appointment data:', e);
                                                                                // Legacy support
                                                                                if (appointmentSetting.start_time && appointmentSetting.end_time) {
                                                                                    selectedDays = ['mon', 'tue', 'wed', 'thu', 'fri']; // Default weekdays
                                                                                    selectedDays.forEach(day => {
                                                                                        dayTimeSlots[day] = [{
                                                                                            start_time: appointmentSetting.start_time,
                                                                                            end_time: appointmentSetting.end_time
                                                                                        }];
                                                                                    });
                                                                                }
                                                                            }
                                                                        } else if (appointmentSetting.start_time && appointmentSetting.end_time) {
                                                                            // Legacy support
                                                                            selectedDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
                                                                            selectedDays.forEach(day => {
                                                                                dayTimeSlots[day] = [{
                                                                                    start_time: appointmentSetting.start_time,
                                                                                    end_time: appointmentSetting.end_time
                                                                                }];
                                                                            });
                                                                        }
                                                                        
                                                                        const dayLabels = {
                                                                            'sun': 'Sunday',
                                                                            'mon': 'Monday', 
                                                                            'tue': 'Tuesday',
                                                                            'wed': 'Wednesday',
                                                                            'thu': 'Thursday',
                                                                            'fri': 'Friday',
                                                                            'sat': 'Saturday'
                                                                        };
                                                                        
                                                                        // Show all 7 days of the week
                                                                        const allDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
                                                                        
                                                                        return allDays.map(day => (
                                                                            <div key={day} className="row justify-content-between" style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '0px' }}>
                                                                                <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                                                                                    <i className="fa fa-calendar" style={{ marginRight: '5px' }}></i>
                                                                                    {dayLabels[day]}
                                                                                </div>
                                                                                <div className="d-flex column" style={{ display: 'flex', gap: '20px', marginBottom: '3px', marginLeft: '20px', flexDirection: 'column' }}>
                                                                                {dayTimeSlots[day] && dayTimeSlots[day].length > 0 ? (
                                                                                    dayTimeSlots[day].map((slot, index) => (
                                                                                        <div key={index} className="d-flex column" style={{ display: 'flex', gap: '20px', marginBottom: '3px', marginLeft: '20px' }}>
                                                                                            {slot.start_time === 'closed' ? (
                                                                                                <span style={{ color: '#dc3545' }}>
                                                                                                    <i className="fa fa-times-circle" style={{ marginRight: '5px' }}></i>
                                                                                                    Closed
                                                                                                </span>
                                                                                            ) : slot.start_time === '0000' && slot.end_time === '2400' ? (
                                                                                                <span style={{ color: '#28a745' }}>
                                                                                                    <i className="fa fa-clock" style={{ marginRight: '5px' }}></i>
                                                                                                    24 Hours Open
                                                                                                </span>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <div className="d-flex gap-2 pt-6" style={{ paddingTop: '6px' }}>
                                                                                                        <i className="fa fa-clock" style={{ marginRight: '5px' }}></i>
                                                                                                        <span>Start: {formatTime(slot.start_time)}</span>
                                                                                                    </div>
                                                                                                    <div className="d-flex gap-2 pt-6" style={{ paddingTop: '6px' }}>
                                                                                                        <i className="fa fa-clock" style={{ marginRight: '5px' }}></i>
                                                                                                        <span>End: {formatTime(slot.end_time)}</span>
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    ))
                                                                                ) : (
                                                                                    <div style={{ marginLeft: '20px' }}>
                                                                                        <span style={{ color: '#dc3545' }}>
                                                                                            <i className="fa fa-times-circle" style={{ marginRight: '5px' }}></i>
                                                                                            Closed
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                                </div>
                                                                            </div>
                                                                        ));
                                                                    })()}
                                                                </div>
                                                        <div className="dc-clinics-title">
                                                            <div className="appointment-details" style={{ marginTop: '10px' }}>
                                                                <div className="time-details" style={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
                                                                    <div>
                                                                        <i className="fa fa-clock-o" style={{ marginRight: '5px' }}></i>
                                                                        <span>Start: {formatTime(appointmentSetting.start_time)}</span>
                                                                    </div>
                                                                    <div>
                                                                        <i className="fa fa-clock-o" style={{ marginRight: '5px' }}></i>
                                                                        <span>End: {formatTime(appointmentSetting.end_time)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="appointment-info" style={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
                                                                    <div style={{ display: 'flex', gap: '10px' }}>
                                                                        <i className="fa fa-hourglass-half" style={{ marginRight: '5px' }}></i>
                                                                        <span>Duration: {formatDuration(appointmentSetting.durations)}</span>
                                                                    </div>
                                                                    <div style={{ display: 'flex', gap: '10px' }}>
                                                                        <i className="fa fa-calendar-check-o" style={{ marginRight: '5px' }}></i>
                                                                        <span>Interval: {formatDuration(appointmentSetting.intervals)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="fee-details" style={{ marginBottom: '8px', display: 'flex', gap: '10px' }}>
                                                                    <i className="fa fa-rupee" style={{ marginRight: '5px' }}></i>
                                                                    <span>Fee: ₹{appointmentSetting.consultant_fee}</span>
                                                                </div>
                                                                <div className="week-days" style={{ marginBottom: '8px', display: 'flex', gap: '10px' }}>
                                                                    <i className="fa fa-calendar" style={{ marginRight: '5px' }}></i>
                                                                    <span>Available Days: {formatWeekDays(appointmentSetting.week_days)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>

                                                    {selectedBreakTime === appointmentSetting.id && (
                                                        <>
                                                            <div>
                                                                <h1>Break Time</h1>
                                                            </div>
                                                            <hr></hr>
                                                            <table className="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Select Date</th>
                                                                        <th>Break Type</th>
                                                                        <th>From Time</th>
                                                                        <th>To Time</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {appointmentSetting.doctor_break_time && appointmentSetting.doctor_break_time.length > 0 ? (
                                                                        appointmentSetting.doctor_break_time.map((breakTime, index) => (
                                                                            <tr key={index}>
                                                                                <td>{breakTime.select_date}</td>
                                                                                <td>{formatBreakType(breakTime.break_type)}</td>
                                                                                <td>{breakTime.from_time}</td>
                                                                                <td>{breakTime.to_time}</td>
                                                                                <td>
                                                                                    <a href="#" className="dc-btn dc-btn-sm dc-btn-danger"><i className="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="5" style={{ textAlign: 'center' }}>No break times found</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                            
                                                            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                                                {selectedBreakTime === appointmentSetting.id ? (
                                                                    <a 
                                                                        href="#" 
                                                                        className="dc-btn dc-btn-sm " 
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setSelectedBreakTime(null);
                                                                        }}
                                                                    >
                                                                        Close
                                                                    </a>
                                                                ) : (
                                                                    null
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="dc-clinics">
                                                <div className="dc-clinics-content">
                                                    <div className="dc-clinics-title">
                                                        No appointment settings found
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 dc-sidebar-grid mt-xl-0">
                            <div className="dc-dashboardbox">
                                <div className="dc-dashboardboxtitle dc-titlewithbtn">
                                    <h2>Add Hospital Timings</h2>
                                    
                                </div>
                                <div className="dc-dashboardboxcontent dc-appsetting">
                                    <div className="dc-tabscontenttitle">
                                        <h3>Add New Hospital Timings</h3>
                                    </div>
                                    <form className="dc-formtheme dc-userform dc-form-appointment dc-hospital-team" onSubmit={handleSubmit}>
                                        <fieldset>
                                            <DayTimeSlots
                                                selectedDays={formData.selected_days}
                                                onDaysChange={(days) => setFormData(prev => ({ ...prev, selected_days: days }))}
                                                dayTimeSlots={formData.day_time_slots}
                                                onTimeSlotsChange={(slots) => setFormData(prev => ({ ...prev, day_time_slots: slots }))}
                                                errors={errors}
                                            />
                                            <div className={`form-group form-group-half ${errors.intervals ? 'has-error' : ''}`}>
                                                <span className="dc-select">
                                                    <select
                                                        name="intervals"
                                                        value={formData.intervals}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Appointment Intervals</option>
                                                        <option value="0">0 minutes</option>
                                                        <option value="5">5 minutes</option>
                                                        <option value="10">10 minutes</option>
                                                        <option value="15">15 minutes</option>
                                                        <option value="20">20 minutes</option>
                                                        <option value="30">30 minutes</option>
                                                        <option value="45">45 minutes</option>
                                                        <option value="60">1 hours</option>
                                                        <option value="90">1 hours, 30 minutes</option>
                                                        <option value="120">2 hours</option>
                                                    </select>
                                                </span>
                                                {errors.intervals && <div className="error-message">{errors.intervals}</div>}
                                            </div>
                                            <div className={`form-group form-group-half ${errors.durations ? 'has-error' : ''}`}>
                                                <span className="dc-select">
                                                    <select
                                                        name="durations"
                                                        value={formData.durations}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Appointment Durations</option>
                                                        <option value="5">5 minutes</option>
                                                        <option value="10">10 minutes</option>
                                                        <option value="15">15 minutes</option>
                                                        <option value="20">20 minutes</option>
                                                        <option value="30">30 minutes</option>
                                                        <option value="45">45 minutes</option>
                                                        <option value="60">1 hours</option>
                                                        <option value="90">1 hours, 30 minutes</option>
                                                        <option value="120">2 hours</option>
                                                        <option value="180">3 hours</option>
                                                        <option value="240">4 hours</option>
                                                        <option value="300">5 hours</option>
                                                        <option value="360">6 hours</option>
                                                        <option value="420">7 hours</option>
                                                        <option value="480">8 hours</option>
                                                    </select>
                                                </span>
                                                {errors.durations && <div className="error-message">{errors.durations}</div>}
                                            </div>
                                            <div className="form-group">
                                                <textarea
                                                    name="content"
                                                    className="form-control"
                                                    placeholder="Your Description"
                                                    value={formData.content}
                                                    onChange={handleInputChange}
                                                ></textarea>
                                            </div>
                                        </fieldset>

                                        <fieldset className="dc-spacesholder">
                                            <div className="form-group">
                                            </div>
                                            <legend>Assign Appointment Spaces:</legend>
                                            <div className={`form-group form-group-half dc-radio-holder ${errors.spaces ? 'has-error' : ''}`}>
                                                <span className="dc-radio">
                                                    <input
                                                        id="dc-spaces1"
                                                        className="dc-spaces"
                                                        type="radio"
                                                        name="spaces"
                                                        value="1"
                                                        checked={formData.spaces === '1'}
                                                        onChange={handleInputChange}
                                                    />
                                                    <label htmlFor="dc-spaces1">01</label>
                                                </span>
                                                <span className="dc-radio">
                                                    <input
                                                        id="dc-spaces2"
                                                        className="dc-spaces"
                                                        type="radio"
                                                        name="spaces"
                                                        value="2"
                                                        checked={formData.spaces === '2'}
                                                        onChange={handleInputChange}
                                                    />
                                                    <label htmlFor="dc-spaces2">02</label>
                                                </span>
                                                <span className="dc-radio">
                                                    <input
                                                        id="dc-others"
                                                        className="dc-spaces"
                                                        type="radio"
                                                        name="spaces"
                                                        value="others"
                                                        checked={formData.spaces === 'others'}
                                                        onChange={handleInputChange}
                                                    />
                                                    <label htmlFor="dc-others">Others</label>
                                                </span>
                                            </div>
                                            {formData.spaces === 'others' && (
                                                <div className={`form-group form-group-half ${errors.custom_spaces ? 'has-error' : ''}`}>
                                                    <input
                                                        type="number"
                                                        name="custom_spaces"
                                                        className="form-control custom_spaces"
                                                        placeholder="Custom Spaces"
                                                        value={formData.custom_spaces}
                                                        onChange={handleInputChange}
                                                        min="1"
                                                    />
                                                    {errors.custom_spaces && <div className="error-message">{errors.custom_spaces}</div>}
                                                </div>
                                            )}
                                        </fieldset>
                                        <fieldset className="dc-offer-holder">
                                            
                                            <legend>Consultation fee:</legend>
                                            <div className={`form-group ${errors.consultant_fee ? 'has-error' : ''}`}>
                                                <input
                                                    type="number"
                                                    name="consultant_fee"
                                                    className="form-control"
                                                    placeholder="Consultation fee"
                                                    value={formData.consultant_fee}
                                                    onChange={handleInputChange}
                                                    min="0"
                                                    step="0.01"
                                                />
                                                {errors.consultant_fee && <div className="error-message">{errors.consultant_fee}</div>}
                                            </div>
                                            <div className={`form-group ${errors.consultant_fee ? 'has-error' : ''}`}>
                                                <span className="dc-select">
                                                    <select
                                                        name="book_before" style={{height: '50px'}}
                                                        className="form-control"
                                                        value={formData.book_before || ''}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Book Appointment Before update</option>
                                                        <option value="0_days">Same Day</option>
                                                        <option value="1_day">1 Day</option>
                                                        <option value="2_days">2 Days</option>
                                                        <option value="3_days">3 Days</option>
                                                    </select>
                                                </span>
                                                {errors.book_before && <div className="error-message">{errors.book_before}</div>}
                                            </div>
                                            <div className="form-group dc-btnarea">
                                                <button 
                                                    type="submit" 
                                                    className="dc-btn dc-add_hospital_teams"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? (isEditing ? 'Updating...' : 'Adding...') : (isEditing ? 'Update Appointment' : 'Add Now')}
                                                </button>
                                                {isEditing && (
                                                    <button 
                                                        type="button" 
                                                        className="dc-btn dc-btn-secondary"
                                                        onClick={resetForm}
                                                        style={{ marginLeft: '10px' }}
                                                    >
                                                        Cancel
                                                    </button>
                                                )}
                                            </div>
                                            {errors.submit && <div className="error-message">{errors.submit}</div>}
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {showBreakTimeModal && (
                    <BreakTimeModal 
                        isOpen={showBreakTimeModal} 
                        onClose={() => setShowBreakTimeModal(false)} 
                        appointment={selectedAppointment}
                        refresh={getAppointmentSettings}
                    />
                )}

                <div className="modal fade dc-invitationmodel" tabIndex="-1" role="dialog" id="dc-invitationmodel">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="dc-modalcontent modal-content">
                            <div className="dc-popuptitle">
                                <h3>Send invitation request</h3>
                                <a href="#" className="dc-closebtn close" data-dismiss="modal" aria-label="Close"><i className="ti-close"></i></a>
                            </div>
                            <div className="modal-body">
                                <form className="dc-formtheme dc-invitation-form" method="post">
                                    <fieldset className="dc-improvedinfo">
                                        <div className="form-group">
                                            <select name="emails[]" className="form-control invitation-3664 select2-hidden-accessible" multiple="" tabIndex="-1" aria-hidden="true">
                                            </select>
                                            <p>You can add multiple email address to send emails in bulk to invite. Type email address and hit enter</p>
                                        </div>
                                        <div className="form-group">
                                            <textarea className="form-control" name="content" placeholder="Your message"></textarea>
                                        </div>
                                    </fieldset>
                                    <fieldset className="dc-formsubmit">
                                        <div className="dc-btnarea">
                                            <a href="#" data-id="4174" className="dc-btn dc-invitation-btn">Submit Now</a>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppointmentSettings;
